import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/images/banner.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  class: "w-7/20",
  src: _imports_0,
  alt: "banner"
}, null, -1)
const _hoisted_2 = { class: "text-14px space-y-6" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-20px font-semibold" }, " Rilis Pembaharuan Fitur ", -1)
const _hoisted_5 = { class: "space-y-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_ImagePreview, {
        key: 0,
        modelValue: _ctx.isBanner,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isBanner = $event)),
        data: _ctx.banners,
        isCustom: !!_ctx.announcementData,
        onClose: _ctx.onHidden
      }, {
        default: _withCtx(() => [
          (!!_ctx.announcementData)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_1,
                _createVNode("div", {
                  class: "w-13/20 p-8 pt-8 bg-white text-black-lp-300 space-y-4 overflow-y-auto banner rounded-r-lg",
                  style: `max-height: ${_ctx.maxHeight}`
                }, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.announcementData.startDate)), 1)
                    ]),
                    _withDirectives(_createVNode("p", _hoisted_5, null, 512), [
                      [_directive_sanitize_html, _ctx.announcementData.announcements]
                    ])
                  ])
                ], 4)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "data", "isCustom", "onClose"]))
    : _createCommentVNode("", true)
}